import React from 'react';

import Icons from '@/core/components/Icons';

interface FullScreenLoaderProps {
  ariaLabel: string;
}
const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ ariaLabel }) => (
  <div aria-label={ariaLabel} className="col-span-12 flex h-[calc(100vh-80px)] items-center justify-center lg:max-h-[calc(100vh-112px)]">
    <Icons icon="spinner" size="40" color="button-default" />
  </div>
);

export default FullScreenLoader;
